module.exports = __webpack_public_path__ + "img/KualaLumpur.94673e69.png";